const Data = [

        {
                "id": 1,
                "title": "IPhone ",
                "description": "It is tipped that this upcoming phone from Apple will come with 4 GB of RAM + 64 GB of internal storage. Hence, you will be able to store all your songs, videos, games and more on the phone without worrying about space constraints. Apart from this, the mobile is likely to be equipped with a powerful Hexa Core (2.65 GHz, Dual core, Lightning + 1.8 GHz, Quad core, Thunder) processor so that you can enjoy a seamless performance while accessing multiple apps and playing intense graphics games.",
                "price": 79999,
                "discountPercentage": 12.96,
                "rating": 4.69,
                "stock": 94,
                "brand": "Apple",
                "category": "smartphones",
                "thumbnail": "https://dummyjson.com/image/i/products/1/thumbnail.jpg",
                "images": [
                        "https://dummyjson.com/image/i/products/2/thumbnail.jpg"
                ]
        },
        {
                "id": 2,
                "title": "iPhone X",
                "description": "The iPhone X has to be one of the most-talked about tech products of 2017, and introduces a brand new paradigm for interaction, with gestures replacing buttons and a larger screen than on any previous iPhone. It shares most of its internals with the iPhone 8 and iPhone 8 Plus, including Apple’s own A11 Bionic chip and support for wireless charging. However, the 5.8-inch AMOLED panel is a first for any iPhone. Overall, the iPhone X display is great. The notch at the top contains the front camera and 3D sensors that make Face ID recognition possible. It works seamlessly and reliably on most occasions. Attention detection ensures that no one can unlock your iPhone X by simply pointing the device at your face when you are not looking. Animoji is a cool new feature that lets you pick an emoji and animate it using your own facial movements. You get optical image stabilisation on both rear cameras, and the iPhone X takes great pictures in nearly all scenarios.  ",
                "price": 58999,                
                "discountPercentage": 17.94,
                "rating": 4.44,
                "stock": 34,
                "brand": "Apple",
                "category": "smartphones",
                "thumbnail": "https://dummyjson.com/image/i/products/2/thumbnail.jpg",
                "images": [
                        "https://dummyjson.com/image/i/products/2/1.jpg",
                        // "https://dummyjson.com/image/i/products/2/2.jpg",
                ]
        },
        {
                "id": 3,
                "title": "Iphone Xs",
                "description": "Apple iPhone XS mobile was launched in September 2018. The phone comes with a 5.80-inch touchscreen display offering a resolution of 1125x2436 pixels at a pixel density of 458 pixels per inch (ppi). The display sports Other for protection. Apple iPhone XS is powered by a hexa-core Apple A12 Bionic processor. The Apple iPhone XS supports wireless charging, as well as proprietary fast charging.",
                "price": 49900,
                "discountPercentage": 15.46,
                "rating": 4.09,
                "stock": 36,
                "brand": "Samsung",
                "category": "smartphones",
                "thumbnail": "https://dummyjson.com/image/i/products/3/thumbnail.jpg",
                "images": [
                        "https://i.gadgets360cdn.com/products/large/1536782640_635_iphone_xs.jpg?downsize=*:180"
                ]
        },
        {
                "id": 4,
                "title": "Iphone Xr",
                "description": "The iPhone XR has arrived to scintillate our senses with a host of features, such as the Liquid Retina Display, a faster Face ID, and a powerful A12 Bionic Chip. Whether it's that picture-perfect portrait shot or a jaw-dropping HDR selfie, the cameras of the iPhone XR will continue to amaze you with their brilliance. Now, experience beauty, in every way. What does the display of the iPhone XR smartphone have in store for you? Its advanced 15.49 cm (6.1) Liquid Retina Display, featuring an innovative backlight technology, allows the screen to stretch to the corners, thereby exposing you to colorful visuals from one edge to another. It also packs enhanced color accuracy and a wide color gamut for delightful visuals.",
                "price": 51999,
                "discountPercentage": 17.91,
                "rating": 4.3,
                "stock": 123,
                "brand": "OPPO",
                "category": "smartphones",
                "thumbnail": "https://dummyjson.com/image/i/products/4/thumbnail.jpg",
                "images": [
                        "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcQuiJIj8hHptzujtmXkLCtNG6vWt_hol6ZBGqWLIzpgjpsIXqlB_LP6HvZVa_dwXye5ZA-V1fHtmnlOYFQHfJL-WkeVdRgSsNqNTg5kkqK3_vhKUOo3cY2g&usqp=CAE"
                ]
        },
        {
                "id": 5,
                "title": "Iphone 11Pro Max",
                "description": " The 6.5-inch, 2688 x 1242 OLED display on Apple's largest phones have been dubbed the 'Super Retina XDR display'. It has a pixel density of 458 pixels per inch, and a 2,000,000 to one contrast ratio, compared to 1,000,000 to one on the iPhone XS and iPhone X. It has a brightness level of 800 nits typically and up to 1200 nits with HDR, whereas the iPhone XS has 625 nits.",
                "price": 55900,
                "discountPercentage": 10.58,
                "rating": 4.09,
                "stock": 32,
                "brand": "Huawei",
                "category": "smartphones",
                "thumbnail": "",
                "images": [
                        "https://www.cnet.com/a/img/resize/b6dd894466dc3a2ecc9334b9dbb98c371b922286/2019/09/16/850d36e0-9bdf-43cf-bef2-31bd5f105924/02-iphone-11-pro-and-iphone-11-max.jpg?auto=webp&fit=crop&height=675&width=1200"
                ]
        },
        {
                "id": 6,
                "title": "MacBook Pro",
                "description": "Apple MacBook Pro is a macOS laptop with a 13.30-inch display that has a resolution of 2560x1600 pixels. It is powered by a Core i5 processor and it comes with 12GB of RAM. The Apple MacBook Pro packs 512GB of SSD storage.  Connectivity options include Wi-Fi 802.11 ac, Bluetooth and it comes with 2 USB ports (2 x USB 3.0), Mic In ports.  As of 3rd August 2022, Apple MacBook Pro price in India starts at Rs. 159,900     ",
                "price": 235102,
                "discountPercentage": 11.02,
                "rating": 4.57,
                "stock": 83,
                "brand": "APPle",
                "category": "laptops",
                "thumbnail": "https://dummyjson.com/image/i/products/6/thumbnail.png",
                "images": [
                        "https://dummyjson.com/image/i/products/6/1.png",
                        // "https://dummyjson.com/image/i/products/6/2.jpg",
                        // "https://dummyjson.com/image/i/products/6/3.png",
                        // "https://dummyjson.com/image/i/products/6/4.jpg"
                ]
        },
        {
                "id": 7,
                "title": "MacBook",
                "description": "Launched in 2008, the Air's touchpad added gesture-based multitouch introduced on the iPhone. In 2018, the Air added a high-res Retina Display, Touch ID and USB-C ports. The Air without the Retina Display screen was the entry-level laptop until 2015. See Macintosh Portable, PowerBook, iBook and Mac computer.        ",
                "price": 142490,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "https://dummyjson.com/image/i/products/7/thumbnail.jpg",
                "images": [
                        // "https://dummyjson.com/image/i/products/7/1.jpg",
                        // "https://dummyjson.com/image/i/products/7/2.jpg",
                        "data:image/jpeg;base64,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"
                        // "https://dummyjson.com/image/i/products/7/3.jpg",
                        // "https://dummyjson.com/image/i/products/7/thumbnail.jpg"
                ]
        },
        {
                "id": 8,
                "title": "MacBook Pro",
                "description": "Style and speed. Stand out on HD video calls backed by Studio Mics. Capture ideas on the vibrant touchscreen.",
                "price": 175410,
                "discountPercentage": 10.23,
                "rating": 4.43,
                "stock": 68,
                "brand": "Microsoft Surface",
                "category": "laptops",
                "thumbnail": "https://dummyjson.com/image/i/products/8/thumbnail.jpg",
                "images": [
                        // "https://dummyjson.com/image/i/products/8/1.jpg",
                        "https://dummyjson.com/image/i/products/8/2.jpg",
                        // "https://dummyjson.com/image/i/products/8/3.jpg",
                        // "https://dummyjson.com/image/i/products/8/4.jpg",
                        // "https://dummyjson.com/image/i/products/8/thumbnail.jpg"
                ]
        },
        {
                "id": 9,
                "title": "MacBook",
                "description": " 10th gen 8GB 256GB 14 Win10 Grey – 1 Year Warranty",
                "price": 116910,
                "discountPercentage": 11.83,
                "rating": 4.54,
                "stock": 96,
                "brand": "Infinix",
                "category": "laptops",
                "thumbnail": "https://dummyjson.com/image/i/products/9/thumbnail.jpg",
                "images": [
                        "https://dummyjson.com/image/i/products/9/1.jpg",
                        // "https://dummyjson.com/image/i/products/9/2.png",
                        // "https://dummyjson.com/image/i/products/9/3.png",
                        // "https://dummyjson.com/image/i/products/9/4.jpg",
                        // "https://dummyjson.com/image/i/products/9/thumbnail.jpg"
                ]
        },
        {
                "id": 10,
                "title": "IPhone",
                "description": "The iPhone 11 display has rounded corners that follow a beautiful curved design, and these corners are within a standard rectangle. When measured as a standard rectangular shape, the screen is 15.40 centimetres (6.06 inches) diagonally (actual viewable area is less).",
                "price": 49999,
                "discountPercentage": 6.18,
                "rating": 4.43,
                "stock": 89,
                "brand": "HP Pavilion",
                "category": "laptops",
                "thumbnail": "https://dummyjson.com/image/i/products/10/thumbnail.jpeg",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcQEQdryOypW_iPe0ZTxy7KiBspjVGRwhWEEcVORijrXnp_fDVW4cWFDpZjk0_Wd_0FxqcFXKU-xmffqJmwjblGfno6UoMPYuuEYrdQ2kkM4gLlPaZgrVekzRQ&usqp=CAE"
                        // "https://dummyjson.com/image/i/products/10/2.jpg",
                        // "https://dummyjson.com/image/i/products/10/3.jpg",
                        // "https://dummyjson.com/image/i/products/10/thumbnail.jpeg"
                ]
        },
        {
                "id": 11,
                "title": " IPhone X",
                "description": "The iPhone X display has rounded corners that follow a beautiful curved design, and these corners are within a standard rectangle. When measured as a standard rectangular shape, the screen is 15.40 centimetres (6.06 inches) diagonally (actual viewable area is less).",
                "price": 70300,
                "discountPercentage": 8.4,
                "rating": 4.26,
                "stock": 65,
                "brand": "Impression of Acqua Di Gio",
                "category": "fragrances",
                "thumbnail": "https://dummyjson.com/image/i/products/11/thumbnail.jpg",
                "images": [
                        // "https://dummyjson.com/image/i/products/11/1.jpg",
                        // "https://dummyjson.com/image/i/products/11/2.jpg",
                        // "https://dummyjson.com/image/i/products/11/3.jpg",
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcTwP0zFr0rrp9VJHBPJ3xjCOn1pFcRoqSzemqsLDwXtk4mlmdvuR-tYfMBTnfnY-7QtEIuSdGTGUU-FOZQ8x9wvDAwBLBiuF1eomc3RJyoEWTFvXEm7D9KOXM-h&usqp=CAE"
                ]
        },
        {
                "id": 12,
                "title": "Iphone 11",
                "description": "The iPhone 11 display has rounded corners that follow a beautiful curved design, and these corners are within a standard rectangle. When measured as a standard rectangular shape, the screen is 15.40 centimetres (6.06 inches) diagonally (actual viewable area is less).",
                "price": 51990,
                "discountPercentage": 15.66,
                "rating": 4,
                "stock": 52,
                "brand": "Royal_Mirage",
                "category": "fragrances",
                "thumbnail": "https://dummyjson.com/image/i/products/12/thumbnail.jpg",
                "images": [
                        // "https://dummyjson.com/image/i/products/12/1.jpg",
                        // "https://dummyjson.com/image/i/products/12/2.jpg",
                        "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcTeggOmW16V58GXizAzzeUXo0Hqdz5H2qQoFliME6tcXot8G6ZpSEVLBF46jOm_W4JtIQycbel48o4xzIggBf7fre9MQ3Qd2DBOC1M4G8JFplhUb4ubZn1WfQ&usqp=CAE"
                        // "https://dummyjson.com/image/i/products/12/4.jpg",
                        // "https://dummyjson.com/image/i/products/12/thumbnail.jpg"
                ]
        },
        {
                "id": 13,
                "title": "Iphone 12 Max",
                "description": "A super-powerful chip. An advanced dual‑camera system. A Ceramic Shield front that’s tougher than any smartphone glass. And a bright, beautiful OLED display. iPhone 12 has it all — in two great sizes.                ",
                "price": 153999,
                "discountPercentage": 8.14,
                "rating": 4.59,
                "stock": 61,
                "brand": "Fog Scent Xpressio",
                "category": "fragrances",
                "thumbnail": "https://dummyjson.com/image/i/products/13/thumbnail.webp",
                "images": [
                        "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcSDbdcheyCFwUNjtYKqGEjcSxwB4iltXWHiP3jgUW55wd2zLJf2GOpsGJlSogfmbG-h1Uyb6rB7k3FwXGghRRqbTGIlJxYmzyJCLZSVLRsXe8k3D9UiEU83gA&usqp=CAE"
                ]
        },
        {
                "id": 14,
                "title": "Iphone 13 Mini",
                "description": "A lightning‑fast chip. A leap in battery life. And all‑new photo and video capabilities. iPhone 13 lets you do things you never could before — in two great sizes.   From ₹69900.00* before trade‑in",
                "price": 69900,
                "discountPercentage": 15.6,
                "rating": 4.21,
                "stock": 114,
                "brand": "Al Munakh",
                "category": "fragrances",
                "thumbnail": "https://dummyjson.com/image/i/products/14/thumbnail.jpg",
                "images": [
                        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtkScJu7uJWUM2HXMluAkmnXHMvWeSoepePg&usqp=CAU"
                        // "https://dummyjson.com/image/i/products/14/2.jpg",
                        // "https://dummyjson.com/image/i/products/14/3.jpg",
                        // "https://dummyjson.com/image/i/products/14/thumbnail.jpg"
                ]
        },
        {
                "id": 15,
                "title": "Iphone 12",
                "description": "24k Gold iPhone 12 Pro Elite 512GB Limited stock available – The most desirable smartphones on the planet. Available in 24k Gold, Rose Gold and Platinum. Delivery time approx. 12 to 15 working days",
                "price": 96500,
                "discountPercentage": 10.99,
                "rating": 4.7,
                "stock": 105,
                "brand": "Lord - Al-Rehab",
                "category": "fragrances",
                "thumbnail": "https://dummyjson.com/image/i/products/15/thumbnail.jpg",
                "images": [
                        "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcQj2L_cpNZEvRWEtO6E6MyJqVD5mrg2Nl2RqFQo1L4kQYX24aAsmsqja7WvKdjj7P1g5_POXzE6hUDNhLVJxVRwiibPRTUZwg&usqp=CAE"
                        // "https://dummyjson.com/image/i/products/15/2.jpg",
                        // "https://dummyjson.com/image/i/products/15/3.jpg",
                        // "https://dummyjson.com/image/i/products/15/4.jpg",
                        // "https://dummyjson.com/image/i/products/15/thumbnail.jpg"
                ]
        },
        {
                "id": 16,
                "title": "iPhone 11 Pro",
                "description": "24k Gold iPhone 11 Pro Elite 512GB Limited stock available – The most desirable smartphones on the planet. Available in 24k Gold, Rose Gold and Platinum. Delivery time approx. 12 to 15 working days",
                "price": 149977,
                "discountPercentage": 13.31,
                "rating": 4.83,
                "stock": 110,
                "brand": "L'Oreal Paris",
                "category": "skincare",
                "thumbnail": "https://dummyjson.com/image/i/products/16/thumbnail.jpg",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcSanj89lExwlr5X0EZK1x8xqTkVVgauD6pu7kvpTVCV4hx4fBFKkK6Mj-8Ss43Vh4Tmo9i7XcRmfEnoo7tfpg1jBKi-FjCVz_qv_qUW9FSjcgW6BSXO7DZzEw&usqp=CAE"
                ]
        },
        {
                "id": 17,
                "title": "Iphone 13 Pro Max",
                "description": "A super-powerful chip. An advanced dual‑camera system. A Ceramic Shield front that’s tougher than any smartphone glass. And a bright, beautiful OLED display. iPhone 12 has it all — in two great sizes                ",
                "price": 74999,
                "discountPercentage": 4.09,
                "rating": 4.52,
                "stock": 78,
                "brand": "Hemani Tea",
                "category": "skincare",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcQMnn7QyTFBCqYjFfwQLSSzcF73-tj8IIdJkE_J58dqoAdc1DahRXVirDye5fyUgc8omzcKpoR4qUsQ-R9wfT79OxaVN0R4aRRwhPwttINaKCNdUGEkECLd&usqp=CAE"
                ]
        },
        {
                "id": 18,
                "title": "Iphone 7",
                "description": "Apple iPhone 7, 128GB, Rose Gold Brand Apple Model iPhone 7 Warranty 6 Month Seller Launched in India Yes Form factor Touchscreen Dimensions (mm) 138.30 x 67.10 x 7.10 Weight (g) 138.00 Battery capacity (mAh) 1960 Removable battery ",
                "price": 24999,
                "discountPercentage": 13.1,
                "rating": 4.56,
                "stock": 88,
                "brand": "Dermive",
                "category": "skincare",
                "thumbnail": "https://dummyjson.com/image/i/products/18/thumbnail.jpg",
                "images": [
                        "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcSrz2RxvuOUVlsIoJxr7ksGT4GsZS5SvZo9iUu21G2yQGPH3oN-PXiVbXPW1PsTdkx1gzFVv4sTbHhbCwjuJe1q64l1bV4De8zOpbKpLtxGUc2q8xV2y60S&usqp=CAE"
                ]
        },
        {
                "id": 19,
                "title": "iPhone 13 Pro Max 24 Carat Gold Plated",
                "description": "Apple iPhone 13 Pro Max 24 Carat Gold Plated",
                "price": 250000,
                "discountPercentage": 10.68,
                "rating": 4.42,
                "stock": 54,
                "brand": "ROREC White Rice",
                "category": "skincare",
                "thumbnail": "https://dummyjson.com/image/i/products/19/thumbnail.jpg",
                "images": [
                                "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcQy5HW5ypu96NIh3oHbIcCRkrskgJonmqTe-Y_GXJIXBLIz3dQRen53vHPMF-daB0slXFMTAD-E2Vu0QMtFj9EQqwR4qexu1GMSTk_Frks&usqp=CAE"
                ]
        },
        {
                "id": 20,
                "title": "IPhone 13",
                "description": "15 cm (6.1-inch) Super Retina XDR display with ProMotion for a faster, more responsive feel.Cinematic mode adds shallow depth of field and shifts focus automatically in your videos.12MP TrueDepth front camera with Night mode, 4K Dolby Vision HDR recording.A15 Bionic chip for lightning-fast performance.Up to 22 hours of video playback.Durable design with Ceramic Shield.Industry-leading IP68 water resistance      Supports MagSafe accessories for easy attachment and faster wireless charging.",
                "price": 79999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "https://dummyjson.com/image/i/products/7/thumbnail.jpg",
                "images": [
                        "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcRNCKsnoVwf4rnVlLsXsiB8HWkVO5G93hWUstU02OsHEB5wZf07DCwMzzR5JSKTg7JZve1Mk-28rpb7aEHVj8U1x4xaUHKgmk_ppg0pmHNN0ZYsaw4FjmiS&usqp=CAE"
                ]
        },
        {
                "id": 21,
                "title": "Apple Iphone 12 Pro",
                "description": "Buy the Apple iPhone 12 Pro which flaunts an amazing display, brilliant camera and powerful processor. Available in awesome colours, it flaunts a stylish design which is easy to hold and is crafted for perfect grip. Its 3110 mAh Lithium-ion battery is perfect for continuous working as long as you don’t give up, because it certainly won’t. It supports up to 50 percent charge in 30 minutes with 20 Watt adapter or higher (sold separately), wireless charging (works with Qi chargers), charging via USB to computer system or power adapter. Use Apple iPhone 11 which has a storage of 64GB that let you store files in ease. This smartphone runs on iOS 14 operating system. It is equipped with Face ID, Barometer, Three-axis gyro, Accelerometer, Proximity sensor, Ambient light sensor. Comes with Siri support as well. It comes with Dual SIM (nano-SIM and eSIM) support. The smartphone features a striking screen which gives you a 15.49 cm all-screen LCD Display. This Liquid Retina HD display offers awesome clarity. Now you can see and do more of what you love, without interruption. The resolution is of 1792 x 828 pixels at 326 ppi. Comes with fingerprint-resistant oleophobic coating. Rated IP68 (maximum depth of up to 200 cm up to 30 minutes) under IEC standard 60529.                ",
                "price": 89999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "https://dummyjson.com/image/i/products/7/thumbnail.jpg",
                "images": [
                        "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcSDbdcheyCFwUNjtYKqGEjcSxwB4iltXWHiP3jgUW55wd2zLJf2GOpsGJlSogfmbG-h1Uyb6rB7k3FwXGghRRqbTGIlJxYmzyJCLZSVLRsXe8k3D9UiEU83gA&usqp=CAE"
                ]
        },
        {
                "id": 22,
                "title": "iphone 11Pro Max",
                "description": "Buy the Apple iPhone 11 which flaunts an amazing display, brilliant camera and powerful processor. Available in awesome colours, it flaunts a stylish design which is easy to hold and is crafted for perfect grip. Its 3110 mAh Lithium-ion battery is perfect for continuous working as long as you don’t give up, because it certainly won’t. It supports up to 50 percent charge in 30 minutes with 20 Watt adapter or higher (sold separately), wireless charging (works with Qi chargers), charging via USB to computer system or power adapter. Use Apple iPhone 11 which has a storage of 64GB that let you store files in ease. This smartphone runs on iOS 14 operating system. It is equipped with Face ID, Barometer, Three-axis gyro, Accelerometer, Proximity sensor, Ambient light sensor. Comes with Siri support as well. It comes with Dual SIM (nano-SIM and eSIM) support. The smartphone features a striking screen which gives you a 15.49 cm all-screen LCD Display. This Liquid Retina HD display offers awesome clarity. Now you can see and do more of what you love, without interruption. The resolution is of 1792 x 828 pixels at 326 ppi. Comes with fingerprint-resistant oleophobic coating. Rated IP68 (maximum depth of up to 200 cm up to 30 minutes) under IEC standard 60529.                ",
                "price": 75900,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcRCqN9ZA3EOcU7KdbdZXGUBaZylLOH5QXp3jr40ZC282ocRTVtMrOq6zE-3LN3MI--mTUZQSbtgVm3L94euM-ZNtzq5x9tlseKNIO1yk-djgUIenfmFaySr&usqp=CAE"
                ]
        },
        {
                "id": 23,
                "title": "Iphone 14 Pro",
                "description": "Available Soon",
                "price": 150000,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://cdn.mos.cms.futurecdn.net/drYWUJb3AjShuf49bstDS3-1200-80.jpg"
                ]
        },
        {
                "id": 24,
                "title": "iphone 8",
                "description": "Apple iPhone 8 (64GB) Space Grey Brand Apple Model iPhone 8 Warranty 6 Month Seller Form factor Touchscreen Body type Glass Dimensions (mm) 138.40 x 67.30 x 7.30 Weight (g) 148.00 IP rating IP67 Battery capacity (mAh) 1821 Removable battery No Wireless charging No Colours Black, Gold, Red, Rose Gold, Silver, Space Grey                ",
                "price": 34999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcRSJnhoq9TaKMDEypEquHZvfAJcMREF0O4zpDuhWcibH1yebSAGKxKnifrE2WrttDXwA4F1BDD6yUiYFcr-ZGnEyOEU0bB3eL3G84x5-HrLlUFJePIOjlaCdg&usqp=CAE"
                ]
        },
        {
                "id": 25,
                "title": "iphone X",
                "description": "Buy Apple iPhone X (256GB) Silver , 5.8 inches (14.73 cm) display size, the iOS 15 operating system at the best price from Triveni World.                ",
                "price": 35999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://i0.wp.com/feshkart.com/wp-content/uploads/2022/05/iphone-x-silver-0-c76d79b.jpg?fit=600%2C450&ssl=1"
                ]
        },
        {
                "id": 26,
                "title": "iphone X",
                "description": "Buy Apple iPhone X (256GB) Silver , 5.8 inches (14.73 cm) display size, the iOS 15 operating system at the best price from Triveni World.                ",
                "price": 45900,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://imageio.forbes.com/blogs-images/gordonkelly/files/2018/09/X-vs-XS.jpg?format=jpg&width=960"
                ]
        },
        {
                "id": 27,
                "title": "iphone XS",
                "description": "Only iPhone No other phone is like iPhone. Only when hardware and software are designed together can they truly work together. teams design the world’s best products, with the most innovative displays, chips, cameras, operating systems, and services. But just as important, the teams collaborate so that all the components of iPhone work together efficiently and beautifully. While this might seem like an obvious way to work, no other smartphone is made this way. And it makes all the difference. It means that the camera team can work with the chip team to leverage the power of the A12 Bionic. So that when you frame a shot, the ISP and Neural Engine identify faces in the frame. Detect specific features. And optimize for lighting, white balance, and more before you even tap the shutter. This is the kind of stuff you’d never even know is happening. You just see the result — the shot you wanted, with more detail, true-to-life color, and dynamic range than you would have thought possible from a smartphone.Less                ",
                "price": 49900,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcSWe5UJYSbQ56-qe6kFBdFLEJd1q51sUyfJ7K2PgGQ3ARRFZvhL_DJ3bkE-aEIbh8_Ra4s8IvEThkFd48QbS-izVHUKrKVs&usqp=CAE"
                ]
        },
        {
                "id": 28,
                "title": "iphone 8",
                "description": "Apple iPhone 8 - A beautiful mind. iPhone 8 64GB introduces an all‐new glass design. The world’s most popular camera, now even better. Wireless charging that’s truly effortless. And augmented reality experiences never before possible. A new generation of iPhone. All‐Glass Design of Apple iPhone 8 The most durable glass ever in a smartphone, front and back. A color‐matched, aerospace‐grade aluminum band. New space gray, silver, and gold finishes. All‐New Sensor in Apple iPhone 8 iPhone 8 features a more advanced 12MP camera. With a larger, faster sensor. A new color filter. Deeper pixels. And optical image stabilization for photos and videos. Amazing Colors in Apple iPhone 8 With a wide color gamut and the best color accuracy in the industry, everything on the screen looks more brilliant and vibrant. True Tone True Tone technology automatically adjusts white balance to match the light around you. For a better viewing experience in all kinds of environments. Buy Apple iPhone 8 64GB Grey in Riyadh, Jeddah, Dammam, and all over Saudi Arabia.Less                ",
                "price": 34999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcRSJnhoq9TaKMDEypEquHZvfAJcMREF0O4zpDuhWcibH1yebSAGKxKnifrE2WrttDXwA4F1BDD6yUiYFcr-ZGnEyOEU0bB3eL3G84x5-HrLlUFJePIOjlaCdg&usqp=CAE"
                ]
        },
        {
                "id": 29,
                "title": "iphone 6",
                "description": "720p HD Video Recording, Retina Flash, f/2.2 Aperture, Auto HDR for Photos and Videos, Backside Illumination Sensor, Exposure Control, Burst Mode, Timer Mode, Face Detection                ",
                "price": 34999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://www.addmecart.com/wp-content/uploads/2021/10/kk14.jpg"
                ]
        },
        {
                "id": 30,
                "title": "iphone 11 Pro Max",
                "description": "6.5-inch (16.5 cm diagonal) Super Retina XDR OLED display Water and dust resistant (4 meters for up to 30 minutes, IP68) Triple-camera system with 12MP Ultra Wide, Wide, and Telephoto cameras; Night mode, Portrait mode, and 4K video up to 60fps 12MP TrueDepth front camera with Portrait Mode, 4K video, and Slo-Mo Face ID for secure authentication A13 Bionic chip with third-generation Neural Engine Fast charge with 18W adapter included Wireless charging iOS with redesigned widgets on the Home screen, all-new App Library, App Clips and moreLess                ",
                "price": 74999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcS9j_IGJ4pTQq3KYrYhfSeLpso-PqGlty-M88fWMlcv2x7iOBrVDgoi82QWR5D4UBZ2u_bNVv56gLWjuT_lQmmmSBCOsycQYT7EocLiCyvIgMN1FlMUyZVI&usqp=CAE"
                ]
        },
        {
                "id": 31,
                "title": "iphone 7",
                "description": "Multi-touch Display, 1400:1 Contrast Ratio, Wide Color Display (P3), 625 cd/m2 Maximum Brightness, Dual Domain Pixels for Wide Viewing Angles, Fingerprint Resistant Oleophobic Coating, Display of Multiple Languages and Characters Simultaneously, Display Zoom, Reachability                ",
                "price": 34999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://shop4deal.in/uploads/products/1609747006.5ff2ca3e8d38c.jpeg"
                ]
        },
        {
                "id": 32,
                "title": "iphone 7 Plus",
                "description": "Apple iPhone 7 Plus, 128GB, Jet Black Brand Apple Model iPhone 7 Plus Warranty 6 Month Seller Form factor Touchscreen.                ",
                "price": 24999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcQqMAqWHhjlYGUGqF2dxBXztL1RbxZ61gjKJ_02CmDV6mXl457QknrQVDhrJPsdvtyUS6g8hGLRFTlVoPTKBlgvabYMFOMPop3yFmofkBthFX1MujJO-uhH&usqp=CAE"
                ]
        },
        {
                "id": 33,
                "title": "iphone 8",
                "description": "Retina Display 5.5   12 megapixel rear-facing camera for high-quality HD photos and videos  NFC support to let you transfer data, pay the shopping bill, buy movie tickets, and more by simply swiping your phone over NFC reader Built-in battery eliminates the need of charging often and provides up to 21 hours of constant talk time",
                "price": 24999,
                "discountPercentage": 4.15,
                "rating": 4.25,
                "stock": 50,
                "brand": "Samsung",
                "category": "laptops",
                "thumbnail": "",
                "images": [
                        "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcROE4FasSk0WAhdloLCUSVn9TT7YndPAf_WFiM4-hGneKDyennyHQZwc7dee-ZeVaZkuQbPrLLh5bhYwuG6lmnLQMaPfl2mzGnEZ2nEmqe9_o29ItLpPXOd&usqp=CAE"
                ]
        },
]

export default Data;